<template>
  <div>
    <b-card-code title="Selecciona el tipo de ingreso">
      <b-row>
        <b-col md="6">
          <v-select v-model="selected.joining_type" :options="options_joining_type" :clearable="false"
            :reduce="item => item.label" />
        </b-col>
        <b-col md="6">
          <div>
            <b-button variant="dark" @click="$router.go(-1)">
              <feather-icon icon="ArrowLeftIcon" class="mr-50" />
              <span class="align-middle">Atrás</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-code>
    <b-card-code title="Ingrese los datos del puesto">
      <b-row>
        <b-col md="4">
          <b-col>
            <b-form-group label="Año Presupuesto" label-for="budget_year">
              <v-select v-model="selected.budget_year" :options="options_budget_year" :clearable="false"
                :disabled="rules.budget_year" id="budget_year" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Tipo de Planilla" label-for="payroll_type">
              <v-select v-model="selected.payroll_type" :options="options_payroll_type" :clearable="false"
                :disabled="rules.payroll_type" id="payroll_type" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Empresa" label-for="company">
              <v-select v-model="selected.company" :options="options_company" :clearable="false" id="company"
                :disabled="rules.company" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Puesto" label-for="position">
              <v-select v-model="selected.position" :options="options_position" :clearable="false" id="position"
                :disabled="rules.position" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Departamento" label-for="department">
              <v-select v-model="selected.department" :options="options_department" :clearable="false"
                :disabled="rules.department" id="department" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Área" label-for="area">
              <v-select v-model="selected.area" :options="options_area" :clearable="false" id="area"
                :disabled="rules.area" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Sección" label-for="section">
              <v-select v-model="selected.section" :options="options_section" :clearable="false" id="section"
                :disabled="rules.section" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Código Ceco" label-for="ceco_code">
              <v-select v-model="selected.ceco_code" :options="options_ceco_code" :clearable="false" id="ceco_code"
                :disabled="rules.ceco_code" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Tipo de Ceco" label-for="ceco_type">
              <b-form-input id="ceco_type" v-model="selected.ceco_type" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Subdivision" label-for="subdivision">
              <v-select v-model="selected.subdivision" :options="options_subdivision" :clearable="false"
                :disabled="rules.subdivision" id="subdivision" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Tipo de Labor" label-for="labor_type">
              <v-select v-model="selected.labor_type" :options="options_labor_type" :clearable="false" id="labor_type"
                :disabled="rules.labor_type" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Estado" label-for="status">
              <v-select v-model="selected.status" :options="options_status" :clearable="false" id="status"
                :disabled="rules.status" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="No. de Organigrama" label-for="organization_chart_id">
              <b-form-input id="organization_chart_id" v-model="selected.organization_chart_id" disabled />
            </b-form-group>
          </b-col>
        </b-col>
        <b-col md="4">
          <b-col>
            <b-form-group label="SAP Código Trabajador" label-for="sap_code">
              <b-form-input id="sap_code" v-model="selected.sap_code" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Número de Documento" label-for="sap_doc_num">
              <b-form-input id="sap_doc_num" v-model="selected.sap_doc_num" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Nombres y Apellidos" label-for="sap_full_name">
              <b-form-input id="sap_full_name" v-model="selected.sap_full_name" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Puesto" label-for="sap_position">
              <b-form-input id="sap_position" v-model="selected.sap_position" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Código Ceco" label-for="sap_ceco_code">
              <b-form-input id="sap_ceco_code" v-model="selected.sap_ceco_code" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Descripcion Ceco" label-for="sap_ceco_description">
              <b-form-input id="sap_ceco_description" v-model="selected.sap_ceco_description" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Descripcion Área" label-for="sap_area_description">
              <b-form-input id="sap_area_description" v-model="selected.sap_area_description" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Departamento" label-for="sap_department">
              <b-form-input id="sap_department" v-model="selected.sap_department" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Área" label-for="sap_area">
              <b-form-input id="sap_area" v-model="selected.sap_area" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Sección" label-for="sap_section">
              <b-form-input id="sap_section" v-model="selected.sap_section" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Periodo de Aplicación" label-for="application_period">
              <v-select v-model="selected.application_period" :options="options_application_period" :clearable="false"
                :disabled="rules.application_period" id="application_period" :reduce="item => item.label" />
            </b-form-group>
          </b-col>
        </b-col>
        <b-col md="4">
          <b-col>
            <b-form-group label="Código de Presupuesto - Reporte Jerarquico" label-for="budget_code_1">
              <v-select v-model="selected.budget_code_1" :options="options_budget_code_1" :clearable="false"
                :reduce="item => item.label" :disabled="rules.budget_code_1" id="budget_code_1" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Código Trabajador - Reporte Jerarquico" label-for="budget_code_1_sap_code">
              <b-form-input id="budget_code_1_sap_code" v-model="selected.budget_code_1_sap_code" disabled />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="SAP Número de Documento - Reporte Jerarquico" label-for="budget_code_1_num_doc">
              <b-form-input id="budget_code_1_num_doc" v-model="selected.budget_code_1_num_doc" disabled />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="SAP Nombres y Apellidos - Reporte Jerarquico" label-for="budget_code_1_full_name">
              <b-form-input id="budget_code_1_full_name" v-model="selected.budget_code_1_full_name" disabled />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="Código de Presupuesto - Reporte Funcional" label-for="budget_code_2">
              <v-select v-model="selected.budget_code_2" :options="options_budget_code_2" :clearable="false"
                :reduce="item => item.label" :disabled="rules.budget_code_2" id="budget_code_2" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Código Trabajador - Reporte Funcional" label-for="budget_code_2_sap_code">
              <b-form-input id="budget_code_2_sap_code" v-model="selected.budget_code_2_sap_code" disabled />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="SAP Número de Documento - Reporte Funcional" label-for="budget_code_2_num_doc">
              <b-form-input id="budget_code_2_num_doc" v-model="selected.budget_code_2_num_doc" disabled />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="SAP Nombres y Apellidos - Reporte Funcional" label-for="budget_code_2_full_name">
              <b-form-input id="budget_code_2_full_name" v-model="selected.budget_code_2_full_name" disabled />
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Semanas" label-for="weeks">
            <div style="overflow-x:auto;">
              <table class="table">
                <thead>
                  <tr>
                    <td>ENERO</td>
                    <td>ENERO</td>
                    <td>ENERO</td>
                    <td>ENERO</td>
                    <td>ENERO</td>
                    <td>FEBRERO</td>
                    <td>FEBRERO</td>
                    <td>FEBRERO</td>
                    <td>FEBRERO</td>
                    <td>MARZO</td>
                    <td>MARZO</td>
                    <td>MARZO</td>
                    <td>MARZO</td>
                    <td>ABRIL</td>
                    <td>ABRIL</td>
                    <td>ABRIL</td>
                    <td>ABRIL</td>
                    <td>MAYO</td>
                    <td>MAYO</td>
                    <td>MAYO</td>
                    <td>MAYO</td>
                    <td>JUNIO</td>
                    <td>JUNIO</td>
                    <td>JUNIO</td>
                    <td>JUNIO</td>
                    <td>JULIO</td>
                    <td>JULIO</td>
                    <td>JULIO</td>
                    <td>JULIO</td>
                    <td>JULIO</td>
                    <td>AGOSTO</td>
                    <td>AGOSTO</td>
                    <td>AGOSTO</td>
                    <td>AGOSTO</td>
                    <td>SEPTIEMBRE</td>
                    <td>SEPTIEMBRE</td>
                    <td>SEPTIEMBRE</td>
                    <td>SEPTIEMBRE</td>
                    <td>OCTUBRE</td>
                    <td>OCTUBRE</td>
                    <td>OCTUBRE</td>
                    <td>OCTUBRE</td>
                    <td>OCTUBRE</td>
                    <td>NOVIEMBRE</td>
                    <td>NOVIEMBRE</td>
                    <td>NOVIEMBRE</td>
                    <td>NOVIEMBRE</td>
                    <td>DICIEMBRE</td>
                    <td>DICIEMBRE</td>
                    <td>DICIEMBRE</td>
                    <td>DICIEMBRE</td>
                    <td>DICIEMBRE</td>
                  </tr>
                  <tr>
                    <td v-if="this.checkIfWeekIsGreater(1)" class="table-primary">SEM 1</td>
                    <td v-else>SEM 1</td>
                    <td v-if="this.checkIfWeekIsGreater(2)" class="table-primary">SEM 2</td>
                    <td v-else>SEM 2</td>
                    <td v-if="this.checkIfWeekIsGreater(3)" class="table-primary">SEM 3</td>
                    <td v-else>SEM 3</td>
                    <td v-if="this.checkIfWeekIsGreater(4)" class="table-primary">SEM 4</td>
                    <td v-else>SEM 4</td>
                    <td v-if="this.checkIfWeekIsGreater(5)" class="table-primary">SEM 5</td>
                    <td v-else>SEM 5</td>
                    <td v-if="this.checkIfWeekIsGreater(6)" class="table-primary">SEM 6</td>
                    <td v-else>SEM 6</td>
                    <td v-if="this.checkIfWeekIsGreater(7)" class="table-primary">SEM 7</td>
                    <td v-else>SEM 7</td>
                    <td v-if="this.checkIfWeekIsGreater(8)" class="table-primary">SEM 8</td>
                    <td v-else>SEM 8</td>
                    <td v-if="this.checkIfWeekIsGreater(9)" class="table-primary">SEM 9</td>
                    <td v-else>SEM 9</td>
                    <td v-if="this.checkIfWeekIsGreater(10)" class="table-primary">SEM 10</td>
                    <td v-else>SEM 10</td>
                    <td v-if="this.checkIfWeekIsGreater(11)" class="table-primary">SEM 11</td>
                    <td v-else>SEM 11</td>
                    <td v-if="this.checkIfWeekIsGreater(12)" class="table-primary">SEM 12</td>
                    <td v-else>SEM 12</td>
                    <td v-if="this.checkIfWeekIsGreater(13)" class="table-primary">SEM 13</td>
                    <td v-else>SEM 13</td>
                    <td v-if="this.checkIfWeekIsGreater(14)" class="table-primary">SEM 14</td>
                    <td v-else>SEM 14</td>
                    <td v-if="this.checkIfWeekIsGreater(15)" class="table-primary">SEM 15</td>
                    <td v-else>SEM 15</td>
                    <td v-if="this.checkIfWeekIsGreater(16)" class="table-primary">SEM 16</td>
                    <td v-else>SEM 16</td>
                    <td v-if="this.checkIfWeekIsGreater(17)" class="table-primary">SEM 17</td>
                    <td v-else>SEM 17</td>
                    <td v-if="this.checkIfWeekIsGreater(18)" class="table-primary">SEM 18</td>
                    <td v-else>SEM 18</td>
                    <td v-if="this.checkIfWeekIsGreater(19)" class="table-primary">SEM 19</td>
                    <td v-else>SEM 19</td>
                    <td v-if="this.checkIfWeekIsGreater(20)" class="table-primary">SEM 20</td>
                    <td v-else>SEM 20</td>
                    <td v-if="this.checkIfWeekIsGreater(21)" class="table-primary">SEM 21</td>
                    <td v-else>SEM 21</td>
                    <td v-if="this.checkIfWeekIsGreater(22)" class="table-primary">SEM 22</td>
                    <td v-else>SEM 22</td>
                    <td v-if="this.checkIfWeekIsGreater(23)" class="table-primary">SEM 23</td>
                    <td v-else>SEM 23</td>
                    <td v-if="this.checkIfWeekIsGreater(24)" class="table-primary">SEM 24</td>
                    <td v-else>SEM 24</td>
                    <td v-if="this.checkIfWeekIsGreater(25)" class="table-primary">SEM 25</td>
                    <td v-else>SEM 25</td>
                    <td v-if="this.checkIfWeekIsGreater(26)" class="table-primary">SEM 26</td>
                    <td v-else>SEM 26</td>
                    <td v-if="this.checkIfWeekIsGreater(27)" class="table-primary">SEM 27</td>
                    <td v-else>SEM 27</td>
                    <td v-if="this.checkIfWeekIsGreater(28)" class="table-primary">SEM 28</td>
                    <td v-else>SEM 28</td>
                    <td v-if="this.checkIfWeekIsGreater(29)" class="table-primary">SEM 29</td>
                    <td v-else>SEM 29</td>
                    <td v-if="this.checkIfWeekIsGreater(30)" class="table-primary">SEM 30</td>
                    <td v-else>SEM 30</td>
                    <td v-if="this.checkIfWeekIsGreater(31)" class="table-primary">SEM 31</td>
                    <td v-else>SEM 31</td>
                    <td v-if="this.checkIfWeekIsGreater(32)" class="table-primary">SEM 32</td>
                    <td v-else>SEM 32</td>
                    <td v-if="this.checkIfWeekIsGreater(33)" class="table-primary">SEM 33</td>
                    <td v-else>SEM 33</td>
                    <td v-if="this.checkIfWeekIsGreater(34)" class="table-primary">SEM 34</td>
                    <td v-else>SEM 34</td>
                    <td v-if="this.checkIfWeekIsGreater(35)" class="table-primary">SEM 35</td>
                    <td v-else>SEM 35</td>
                    <td v-if="this.checkIfWeekIsGreater(36)" class="table-primary">SEM 36</td>
                    <td v-else>SEM 36</td>
                    <td v-if="this.checkIfWeekIsGreater(37)" class="table-primary">SEM 37</td>
                    <td v-else>SEM 37</td>
                    <td v-if="this.checkIfWeekIsGreater(38)" class="table-primary">SEM 38</td>
                    <td v-else>SEM 38</td>
                    <td v-if="this.checkIfWeekIsGreater(39)" class="table-primary">SEM 39</td>
                    <td v-else>SEM 39</td>
                    <td v-if="this.checkIfWeekIsGreater(40)" class="table-primary">SEM 40</td>
                    <td v-else>SEM 40</td>
                    <td v-if="this.checkIfWeekIsGreater(41)" class="table-primary">SEM 41</td>
                    <td v-else>SEM 41</td>
                    <td v-if="this.checkIfWeekIsGreater(42)" class="table-primary">SEM 42</td>
                    <td v-else>SEM 42</td>
                    <td v-if="this.checkIfWeekIsGreater(43)" class="table-primary">SEM 43</td>
                    <td v-else>SEM 43</td>
                    <td v-if="this.checkIfWeekIsGreater(44)" class="table-primary">SEM 44</td>
                    <td v-else>SEM 44</td>
                    <td v-if="this.checkIfWeekIsGreater(45)" class="table-primary">SEM 45</td>
                    <td v-else>SEM 45</td>
                    <td v-if="this.checkIfWeekIsGreater(46)" class="table-primary">SEM 46</td>
                    <td v-else>SEM 46</td>
                    <td v-if="this.checkIfWeekIsGreater(47)" class="table-primary">SEM 47</td>
                    <td v-else>SEM 47</td>
                    <td v-if="this.checkIfWeekIsGreater(48)" class="table-primary">SEM 48</td>
                    <td v-else>SEM 48</td>
                    <td v-if="this.checkIfWeekIsGreater(49)" class="table-primary">SEM 49</td>
                    <td v-else>SEM 49</td>
                    <td v-if="this.checkIfWeekIsGreater(50)" class="table-primary">SEM 50</td>
                    <td v-else>SEM 50</td>
                    <td v-if="this.checkIfWeekIsGreater(51)" class="table-primary">SEM 51</td>
                    <td v-else>SEM 51</td>
                    <td v-if="this.checkIfWeekIsGreater(52)" class="table-primary">SEM 52</td>
                    <td v-else>SEM 52</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><input type="checkbox" :checked="selected.weeks.sem1" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem1"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem2" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem2"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem3" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem3"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem4" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem4"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem5" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem5"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem6" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem6"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem7" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem7"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem8" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem8"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem9" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem9"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem10" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem10"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem11" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem11"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem12" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem12"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem13" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem13"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem14" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem14"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem15" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem15"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem16" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem16"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem17" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem17"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem18" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem18"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem19" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem19"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem20" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem20"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem21" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem21"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem22" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem22"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem23" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem23"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem24" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem24"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem25" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem25"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem26" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem26"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem27" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem27"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem28" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem28"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem29" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem29"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem30" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem30"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem31" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem31"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem32" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem32"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem33" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem33"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem34" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem34"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem35" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem35"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem36" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem36"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem37" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem37"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem38" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem38"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem39" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem39"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem40" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem40"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem41" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem41"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem42" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem42"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem43" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem43"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem44" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem44"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem45" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem45"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem46" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem46"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem47" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem47"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem48" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem48"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem49" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem49"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem50" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem50"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem51" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem51"></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem52" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem52"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Total de semanas seleccionadas" label-for="total_weeks">
            <b-form-input id="total_weeks" v-model="selected.total_weeks" disabled />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <!-- submit and reset -->
        <b-col md="3">
          <div>
            <b-button variant="primary" @click="saveData">
              <feather-icon icon="SaveIcon" class="mr-50" />
              <span class="align-middle">Guardar cambios</span>
            </b-button>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-input type="number" v-model="cant_registry" min="0" step="1" />
        </b-col>
      </b-row>
    </b-card-code>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      options_joining_type: [],
      options_budget_year: [],
      options_payroll_type: [],
      options_company: [],
      options_position: [],
      options_department: [],
      options_area: [],
      options_section: [],
      options_ceco_code: [],
      options_subdivision: [],
      options_labor_type: [],
      options_status: [],
      options_sap_code: [],
      options_application_period: [],
      options_budget_code_1: [],
      options_budget_code_2: [],
      selected: {
        joining_type: 'Posición Nueva',
        budget_year: null,
        payroll_type: null,
        company: null,
        position: null,
        department: null,
        area: null,
        section: null,
        ceco_code: null,
        ceco_type: null,
        subdivision: null,
        labor_type: null,
        status: null,
        organization_chart_id: null,
        budget_code_1: null,
        budget_code_1_sap_code: null,
        budget_code_1_num_doc: null,
        budget_code_1_full_name: null,
        budget_code_2: null,
        budget_code_2_sap_code: null,
        budget_code_2_num_doc: null,
        budget_code_2_full_name: null,
        sap_code: null,
        sap_doc_num: null,
        sap_full_name: null,
        sap_position: null,
        sap_ceco_code: null,
        sap_ceco_description: null,
        sap_area_description: null,
        sap_department: null,
        sap_area: null,
        sap_section: null,
        weeks: {
          sem1: true,
          sem2: true,
          sem3: true,
          sem4: true,
          sem5: true,
          sem6: true,
          sem7: true,
          sem8: true,
          sem9: true,
          sem10: true,
          sem11: true,
          sem12: true,
          sem13: true,
          sem14: true,
          sem15: true,
          sem16: true,
          sem17: true,
          sem18: true,
          sem19: true,
          sem20: true,
          sem21: true,
          sem22: true,
          sem23: true,
          sem24: true,
          sem25: true,
          sem26: true,
          sem27: true,
          sem28: true,
          sem29: true,
          sem30: true,
          sem31: true,
          sem32: true,
          sem33: true,
          sem34: true,
          sem35: true,
          sem36: true,
          sem37: true,
          sem38: true,
          sem39: true,
          sem40: true,
          sem41: true,
          sem42: true,
          sem43: true,
          sem44: true,
          sem45: true,
          sem46: true,
          sem47: true,
          sem48: true,
          sem49: true,
          sem50: true,
          sem51: true,
          sem52: true,
        },
        total_weeks: 0,
        user_id: this.getUserID(),
        application_period: null,
      },
      rules_list: [],
      rules: {
        budget_year: false,
        budget_code: false,
        payroll_type: false,
        company: false,
        position: false,
        department: false,
        area: false,
        section: false,
        ceco_code: false,
        ceco_type: false,
        subdivision: false,
        labor_type: false,
        status: false,
        organization_chart_id: false,
        sap_data: false,
        budget_code_1: false,
        budget_code_2: false,
        weeks: false,
        application_period: true,
      },
      cant_registry: 1,
    }
  },
  methods: {
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const { id } = jsonUserData
      return id
    },
    getOptionsJoiningType() {
      const URL = '/nomina/options/entry_type'
      const config = {
        method: 'get', url: URL, params: {
          type: 'new'
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_joining_type = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsBudgetYear() {
      const URL = '/nomina/options/budget_year'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_budget_year = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsPayrollType() {
      const URL = '/nomina/options/payroll_type'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_payroll_type = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsCompany() {
      const URL = '/nomina/options/company_type'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_company = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsPosition() {
      const URL = '/nomina/options/organizational_Pos'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_position = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsDepartment() {
      const URL = '/nomina/options/DAS'
      const config = {
        method: 'get', url: URL, params: {
          das: 'd',
          element: ''
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_department = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsArea() {
      const URL = '/nomina/options/DAS'
      const config = {
        method: 'get', url: URL, params: {
          das: 'a',
          element: this.selected.department
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_area = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsSection() {
      const URL = '/nomina/options/DAS'
      const config = {
        method: 'get', url: URL, params: {
          das: 's',
          element: this.selected.area
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_section = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsCecoCode() {
      const URL = '/nomina/options/ceco_code'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_ceco_code = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsSubdivision() {
      const URL = '/nomina/options/subdivision'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_subdivision = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsJobType() {
      const URL = '/nomina/options/labor_type'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_labor_type = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsStatus() {
      const URL = '/nomina/options/status'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_status = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsSAPCode() {
      const URL = '/nomina/options/sap_code'
      const config = { method: 'get', url: URL, params: { user_id: this.getUserID() } }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_sap_code = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsBudgetCode1() {
      const URL = '/nomina/options/budget_code'
      const config = {
        method: 'get', url: URL, params: {
          budget_code: 'X'
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_budget_code_1 = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsBudgetCode2() {
      const URL = '/nomina/options/budget_code'
      const config = {
        method: 'get', url: URL, params: {
          budget_code: 'X'
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_budget_code_2 = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    saveData() {
      if (!this.formIsValid()) {
        this.$swal({
          title: 'Formulario Incompleto',
          text: 'Por favor completa todos los campos del formulario e intenta nuevamente.',
          icon: 'error',
          confirmButtonText: 'Cerrar',
        })
        return
      }
      this.$swal({
        title: '¿Estas seguro?',
        text: 'Se guardarán los cambios realizados',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar cambios',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // Check if multiple records for creation are selected
          let config = {}
          if (this.cant_registry > 1) {
            // Se manda a crear una lista de registros
            const lstData = []
            for (let i = 0; i < this.cant_registry; i++) {
              lstData.push(this.selected)
            }
            const URL = '/nomina/save_multiple_request'
            config = {
              method: 'post', url: URL, data: { data: lstData, app_user_id: this.getUserID(), user_id: this.getUserID() },
            }
          } else {
            // Solo se crea 1 registro
            const URL = '/nomina/save_request'
            config = {
              method: 'post', url: URL, data: { ...this.selected, app_user_id: this.getUserID() },
            }
          }
          // Send data to server
          console.log(config)
          axiosIns(config)
            .then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: '¡Guardado!',
                  text: 'La información del puesto ha sido registrada',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(x => this.$router.push({ name: 'request' }))

              } else {
                this.printErrorModal('Error en el servidor')
              }
            })
            .catch(error => {
              this.printErrorModal(error)
            })
        }
      })
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    reCalculateTotalWeeks() {
      let cont = 0
      for (const sem in this.selected.weeks) {
        if (this.selected.weeks[sem]) {
          cont = cont + 1
        }
      }
      this.selected.total_weeks = cont
    },
    getOrgNumber() {
      const URL = '/nomina/get_org_number'
      const config = {
        method: 'get', url: URL, params: {
          section: this.selected.section,
          app_user_id: this.getUserID(),
        }
      }
      this.selected.organization_chart_id = null
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.organization_chart_id = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getSAPDataBudgetCode1() {
      const URL = '/nomina/get_sap_data'
      const config = {
        method: 'get', url: URL, params: {
          budget_code: this.selected.budget_code_1,
          app_user_id: this.getUserID(),
        }
      }

      this.selected.budget_code_1_sap_code = null
      this.selected.budget_code_1_num_doc = null
      this.selected.budget_code_1_full_name = null

      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.budget_code_1_sap_code = response.data.response["sap_code"]
            this.selected.budget_code_1_num_doc = response.data.response["doc_num"]
            this.selected.budget_code_1_full_name = response.data.response["full_name"]
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getSAPDataBudgetCode2() {
      const URL = '/nomina/get_sap_data'
      const config = {
        method: 'get', url: URL, params: {
          budget_code: this.selected.budget_code_2,
          app_user_id: this.getUserID(),
        }
      }

      this.selected.budget_code_2_sap_code = null
      this.selected.budget_code_2_num_doc = null
      this.selected.budget_code_2_full_name = null


      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.budget_code_2_sap_code = response.data.response["sap_code"]
            this.selected.budget_code_2_num_doc = response.data.response["doc_num"]
            this.selected.budget_code_2_full_name = response.data.response["full_name"]
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getCecoType() {
      const URL = '/nomina/ceco_type'
      const config = {
        method: 'get', url: URL, params: {
          ceco_code: this.selected.ceco_code
        }
      }
      this.selected.ceco_type = null
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.ceco_type = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getOptionsApplicationPeriod() {
      const URL = '/nomina/options/weeks'
      const config = { method: 'get', url: URL }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.options_application_period = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    checkIfWeekIsGreater(single_week) {
      // Guard clause
      if (!this.selected.application_period) {
        return false
      }

      let isGreater = false
      let number = this.selected.application_period.match(/(\d+)/)[0];
      if (single_week >= number) {
        isGreater = true
      }
      return isGreater
    },
    formIsValid() {
      if (!this.selected.joining_type) return false
      if (!this.selected.budget_year) return false
      if (!this.selected.company) return false
      if (!this.selected.position) return false
      if (!this.selected.department) return false
      if (!this.selected.area) return false
      if (!this.selected.section) return false
      if (!this.selected.ceco_code) return false
      if (!this.selected.subdivision) return false
      if (!this.selected.labor_type) return false
      if (!this.selected.status) return false
      if (!this.selected.budget_code_1) return false
      if (!this.selected.budget_code_2) return false
      return true
    }
  },
  mounted() {
    this.getOptionsJoiningType()
    this.getOptionsBudgetYear()
    this.getOptionsPayrollType()
    this.getOptionsCompany()
    this.getOptionsPosition()
    this.getOptionsDepartment()
    this.getOptionsCecoCode()
    this.getOptionsSubdivision()
    this.getOptionsJobType()
    this.getOptionsStatus()
    this.getOptionsSAPCode()
    this.getOptionsBudgetCode1()
    this.getOptionsBudgetCode2()
    this.getOptionsApplicationPeriod()
    this.reCalculateTotalWeeks()
  },
  watch: {
    'selected.department'(newDepartment, oldDepartment) {
      this.selected.area = null
      this.selected.section = null
      this.selected.organization_chart_id = null
      if (newDepartment) {
        this.getOptionsArea()
      }
    },
    'selected.area'(newArea, oldArea) {
      this.selected.section = null
      this.selected.organization_chart_id = null
      if (newArea) {
        this.getOptionsSection()
      }
    },
    'selected.section'(newSection, oldSection) {
      this.selected.organization_chart_id = null
      if (newSection) {
        this.getOrgNumber()
      }
    },
    'selected.budget_code_1'(newBudgetCode1, oldBudgetCode1) {
      this.getSAPDataBudgetCode1()
    },
    'selected.budget_code_2'(newBudgetCode2, oldBudgetCode2) {
      this.getSAPDataBudgetCode2()
    },
    'selected.ceco_code'(newCecoType, oldCecoType) {
      this.getCecoType()
    },
    'selected.joining_type'(newJoining, oldJoining) {
      this.selected.application_period = null
      if (newJoining === 'Puesto nuevo- procede de empleado') {
        this.rules.application_period = false
      } else {
        this.rules.application_period = true
      }
    },
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>